(ns machtfit.repository.products
  (:require [cljs-time.core :as t]
            [clojure.walk :as walk]
            [machtfit.api :as api]
            [machtfit.datetime :as datetime]
            [machtfit.repository.core :as repository]
            [machtfit.repository.query :as query]
            [machtfit.startpage.products-cache :as products-cache]
            [medley.core :refer [map-vals]]
            [re-frame.core :as rf])
  (:require-macros [reagent.ratom :refer [reaction]]))

(def ^:private db-path-products
  (conj repository/db-path-base :products-data))

(def ^:private fetch-query-id
  [::fetch])

(defn- make-maps [data]
  (if (map? data)
    (let [{:keys [header products]} data
          header (map keyword header)]
      (map (partial zipmap header) products))
    data))

(defn- by-id [data]
  (->> data
       make-maps
       (group-by :id)
       (map-vals first)))

(defn- set-completed [db products]
  (assoc-in db db-path-products {:status :done
                                 :products products}))

(defn prepare-date-for-products [m]
  (walk/postwalk
   (fn [v]
     (if (t/date? v)
       (datetime/date->inst v)
       v))
   m))

(defn- prepare-products [products]
  (walk/postwalk
   (fn [data]
     (cond-> data
       (and (map? data)
            (contains? data :labels)
            (not (set? (:labels data)))) (update :labels set)
       (map? data) prepare-date-for-products))
   products))

(defn payload->products
  "Prepared product maps for a products-faster ``{:header :products}`` projection,
  in payload order."
  [payload]
  (prepare-products (make-maps payload)))

(rf/reg-event-fx ::store
  (fn [{:keys [db]} [_ products]]
    (products-cache/store
     (conj db-path-products :products)
     {:db (set-completed db (prepare-products products))})))

(rf/reg-event-fx ::store-from-cache
  (fn [{:keys [db]} [_ products]]
    {:db (set-completed db products)}))

(rf/reg-event-db ::reset
  (fn [db _]
    (assoc-in db db-path-products nil)))

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} _]
    (cond
      (and (products-cache/ready? db)
           (products-cache/hit? db)) {:dispatch [::store-from-cache (products-cache/cached-products db)]}

      (query/running? db fetch-query-id) {}

      :else (let [location (get-in db [:products-location :coordinates])]
              {:dispatch [::query/register fetch-query-id]
               :post (api/request db
                                  {:data `[(:products-faster {:location ~location} :products)]
                                   :on-error #(rf/dispatch [::query/unregister fetch-query-id])
                                   :on-success #(do
                                                  (rf/dispatch [::query/unregister fetch-query-id])
                                                  (rf/dispatch [::store (-> % :result :products :result by-id)]))})}))))

(rf/reg-sub-raw ::data
  (fn [_ _]
    (reaction
     (repository/async-query-data db-path-products #(rf/dispatch [::fetch])))))

(rf/reg-sub ::data-without-fetching
  :<- [:get (conj db-path-products :products)]

  (fn [products _]
    products))

;; this is a crutch currently for some legacy code that needs to access products
;; data from db
(defn from-db [db]
  (get-in db (conj db-path-products :products)))
